import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { LocationService } from '../../Services/location.service';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { Router } from '@angular/router';
import { VERBIAGE } from 'src/app/config';

@Component({
    selector: 'location-add',
    templateUrl: './location-add.component.html',
    styleUrls: ['./location-add.component.scss']
})

export class LocationAddComponent implements OnInit, OnDestroy {
    address; regions;
    showMap: boolean = false;
    sameRegionError: boolean = false;

    // Set input masks for form controls
    inputMask = { phone: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] };

    constructor(
        private _shared: SharedService,private _location: LocationService, private _zone: NgZone,
        private _notify: NotificationService, private _router: Router
    ) {
        // Setting up padge title
        this._shared.pageTitle = 'Add New Location';

        // Adding page controls
        const _this = this;
        this._shared.pageControls = [
            { type: '-icon-', title: 'Previous page', icon: 'arrow_back', action() {
                _this._router.navigate([(_this._shared.getPreviousUrl !== _this._router.url) ? _this._shared.getPreviousUrl : '/dashboard/locations']);
            }}
        ];
    }

    ngOnInit() {
        // Get regions of country
        this._location.getRegions().subscribe(res => this.regions = res['result']);
    }

    checkRegionName(regionName: string, form) {
        let region = this.regions.filter(r => r.regionName.toLowerCase() === regionName.trim().toLowerCase()).shift();
        if (region) {
            this.sameRegionError = true;
            form.controls['regionName'].setErrors({ 'incorrect': true });
        } else {
            this.sameRegionError = false;
        }
    }

    getAddress(address) {
        // Google places autocomplete.
        this._zone.run(() => {
            this.address = address; this.address['zoom'] = 0;

            // Mapping address_1
            if (this.address.street_number && this.address.route) {
                this.address['regional_address_1'] = this.address.street_number + ' ' + this.address.route;
            } else if (this.address.street_number && this.address.route === undefined) {
                this.address['regional_address_1'] = this.address.street_number;
            } else if (this.address.street_number === undefined && this.address.route) {
                this.address['regional_address_1'] = this.address.route;
            }

            // Mapping address_2
            if (this.address.neighborhood) {
                this.address['regional_address_2'] = this.address.neighborhood;
            }

            // Animate map
            let interval = setInterval(() => {
                this.address['zoom'] += 0.5;
                if (this.address['zoom'] === 16) { clearInterval(interval); }
            }, 100);
        });
    }

    reverseGeocode(e) {
        this.address.lat = e.coords.lat; this.address.lng = e.coords.lng;
    }

    addLocation(form) {
        if (form.valid) {
            this._location.addLocation(form.value).subscribe(res => {
                if (res['status'] === 'OK') {
                    this._notify.toastMessage({
                        color: 'accent', message: VERBIAGE.SERVICE_CENTER_ADD_SUCCESS, duration: 3000
                    });
                    this._router.navigate(['/dashboard/locations']);
                }
            }, err => this._notify.toastMessage({ color: 'warn', message: VERBIAGE.SERVICE_CENTER_ADD_FAIL, duration: 3000 }))

            return;
        }

        this._notify.toastMessage({ color: 'warn', message: VERBIAGE.SERVICE_CENTER_FORM_ERROR, duration: 3000 })
    }

    ngOnDestroy() {
        // Removing page controls
        this._shared.pageControls = null;
    }
}